import { extendTheme } from '../../../theme';
import defaultTheme from '../../../theme/default-theme';
import { NIColours } from './NIColours';
import { Accordion, ActionBar, ActivityFeed, ActivityItem, ActivityStartItem, Alert, AttentionMessage, Badge, Button, Card, Checkbox, DatePicker, DetailsCard, ExpandableParagraph, Form, Heading, IconButton, Input, InfoBanner, Link, Listbox, ListItemRow, Menu, Modal, NIFooter, NumberInput, Pagination, Progress, Radio, SearchInput, Select, StatusLabel, Steps, SuccessBanner, Table, Tabs, Tag, Text, Textarea, Toast, Toggler, WarningBanner } from './components';
var arialSansFont = 'Arial, Helvetica, sans-serif';
var theme = extendTheme(defaultTheme, {
  name: 'PP2 Northern Ireland',
  fonts: {
    heading: arialSansFont,
    body: arialSansFont
  },
  colors: NIColours,
  components: {
    ActionBar,
    Alert,
    AttentionMessage,
    Button,
    Badge,
    Card,
    Checkbox,
    DatePicker,
    Heading,
    Text,
    Tabs,
    Link,
    Menu,
    Modal,
    IconButton,
    ExpandableParagraph,
    ListItemRow,
    Accordion,
    ActivityFeed,
    ActivityItem,
    ActivityStartItem,
    DetailsCard,
    Textarea,
    Input,
    Select,
    NIFooter,
    Form,
    SuccessBanner,
    Toast,
    Steps,
    Radio,
    Table,
    Tag,
    Toggler,
    SearchInput,
    Progress,
    Listbox,
    NumberInput,
    Pagination,
    StatusLabel,
    InfoBanner,
    WarningBanner
  }
});
export default theme;